/**
 * What a queue zone is called on screen (14 Oct 2026): "Zone 1", "Zone 2" ... in route order (city -> temple).
 * The backend ids (Q1 ... Q5) stay the keys for resets, cameras and settings; only the name shown changes. The darshan
 * LANES inside the temple (count lines Q1-Q6 on the scanning cameras) are something else and keep their Q names.
 */
export const zoneLabel = (index: number) => `Zone ${index + 1}`;

/** "Q3" -> "Zone 3" for a zone id shown as it is; any other id is returned unchanged. */
export const zoneLabelFromId = (id: string) => (/^Q\d+$/.test(id) ? `Zone ${id.slice(1)}` : id);
